import React from 'react'
import './aqua.scss';

const Aqua = () => {
    return (
        <>
            <section className='aqua_main'>
                <img src='\assets\aquanew.png' className='aquashade1' />
                <img src='\assets\aquaright.png' className='aquashade2' />
                <div className='inner_aqua'>
                    <div className='custom-container'>

                          <img src='\assets\aquashade.png' className='aquashade' />

                    <h2>Join the <span>Aqua</span>  community</h2>
                    <p>Connect and engage to help redefine the boundaries of what's possible with DeFi.</p>
                    <div className='new_head_cards'>
                        <div className='card_new'>
                            <img src='\assets\x.svg' />
                            <h3>X (Twitter)</h3>
                        </div>
                        <div className='card_new'>
                            <img src='\assets\git.svg' />
                            <h3>Github</h3>
                        </div>
                        <div className='card_new'>
                            <img src='\assets\dis.svg' />
                            <h3>Discord</h3>
                        </div>
                        <div className='card_new'>
                            <img src='\assets\tel.svg' />
                            <h3>Telegram</h3>
                        </div>
                        <div className='card_new'>
                            <img src='\assets\you.svg' />
                            <h3>Youtube</h3>
                        </div>
                        <div className='card_new'>
                            <img src='\assets\insta.svg' />
                            <h3>Instagram</h3>
                        </div>

                    </div>
                    </div>

                </div>
            </section>
        </>
    )
}

export default Aqua
